module.exports = __webpack_public_path__ + "static/purpleSquiggle-9d2b8e5f24fcc66759430dfd87e6ac9a.png";